import { AsyncData, Keyable } from '@model/common';
import { DestinationFaqApi } from '@model/iceberg/service/geography/destination-faq-api';
import { DataEnvelope } from '@model/iceberg';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum DestinationFaqActions {
  NAME = '@DESTINATION_FAQ',
  PERFORM_FETCH_FAQ = '@DESTINATION_FAQ/fetchDestinationFaq',
  RECEIVE_FAQ_SUCCESS = '@DESTINATION/RECEIVE_FAQ_SUCCESS',
  RECEIVE_FAQ_FAILURE = '@DESTINATION/RECEIVE_FAQ_FAILURE'
}

export interface DestinationFaqItem {
  id: number;
  title: string;
  description: string;
  destination_name: string;
}

export type DestinationFaqResponse = DataEnvelope<Array<DestinationFaqItem>>;

export interface ErrorDetails {
  status: number | string;
  data?: Keyable;
}

export interface DestinationFaqRequestPayload {
  path: string;
}

export const INITIAL_DESTINATION_FAQ_STATE: AsyncData<Array<DestinationFaqItem>> = {
  data: [] as any,
  loading: false,
  error: null
};

export const fetchDestinationFaq = createAsyncThunk(
  DestinationFaqActions.PERFORM_FETCH_FAQ,
  async (payload: DestinationFaqRequestPayload, { rejectWithValue }) => {
    try {
      const api = new DestinationFaqApi();
      const response: DestinationFaqResponse = await api.getDestinationFaq(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data
      });
    }
  }
);

const destinationFaqSlice = createSlice({
  name: DestinationFaqActions.NAME,
  initialState: INITIAL_DESTINATION_FAQ_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDestinationFaq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDestinationFaq.fulfilled, (state, action: PayloadAction<Array<DestinationFaqItem>>) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDestinationFaq.rejected, (state, action) => {
        state.data = INITIAL_DESTINATION_FAQ_STATE.data;
        state.loading = false;
        state.error = action.payload as ErrorDetails;
      });
  }
});

export const destinationFaqReducer = destinationFaqSlice.reducer;
